import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "sales-quote"
    }}>{`Sales Quote`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Sales teams create many sales quotes for customers, and quotes need to be polished and accurate. Quotes include complex product pricing configurations and payment conditions, and they usually include information from the team’s CPQ software system. For many teams, this manual process takes away valuable time. Automating the process ensures information is accurate and delivered quickly.`}</p>
    <p>{`Adobe Acrobat Services allows sales teams to:`}</p>
    <ul>
      <li parentName="ul">{`Create standard branded templates for sales quotes`}</li>
      <li parentName="ul">{`Merge complex quote data automatically into templates`}</li>
      <li parentName="ul">{`Add or exclude any standard document sections based on quote data`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.io/apis/documentcloud/sign.html"
        }}>{`Adobe Acrobat Sign API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A B2B sales team needs to generate polished quotes for their consulting services from the data in their CPQ system. In addition, they want to include terms and conditions if certain products are included in the quote. Automating this process means the sales team will create the appropriate quote in just a few clicks.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create a simple data capture form using Microsoft Form (or another form builder)`}</li>
      <li parentName="ol">{`Design the sales quote template using Microsoft Word`}</li>
      <li parentName="ol">{`Use Adobe Document Generation Tagger in Word to place fields into the template based on the data model from the form`}</li>
      <li parentName="ol">{`Run the Adobe Document Generation API to merge data from the form into the template, creating a final sales quote in PDF`}</li>
      <li parentName="ol">{`Send to Adobe Acrobat Sign if signatures are required, and if not, email directly`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      